import Handlebars from 'handlebars/runtime';
import {x2xxPlats, get_version} from '../utes/appUtils.js';
// this will be built by 'npm run precompile_templates' which is part of the build process
import './board_h_template_precompiled.js';

export function HandlebarTemplateSetup(){
    /**
     *  returns capitalizes passed string
     **/
    Handlebars.registerHelper('upperCase',function(str) {
        return str.toUpperCase();
    });

    /**
     *  returns true if the two variables are equal
     **/
    Handlebars.registerHelper('ifeq', function (a, b, options) {
        if (a === b) { return options.fn(this); }
        return options.inverse(this);
    });
    /**
     *  returns true if b is a substring of a
     **/
    Handlebars.registerHelper('ifincl', function (a, b, options) {
        if (a.includes(b)) { return options.fn(this); }
        return options.inverse(this);
    });
    /**
     *  returns true if b is NOT a substring of a
     **/
    Handlebars.registerHelper('ifnincl', function (a, b, options) {
        if (!a.includes(b)) { return options.fn(this); }
        return options.inverse(this);
    });
    /**
     *  returns str with first occurance of ch removed
     **/
    Handlebars.registerHelper('removeFirst', function (str, ch, options) {
        return str.replace(ch, '');
    });

    /**
     *  returns true if peri has secondary pin
     **/
    Handlebars.registerHelper('ifsec', function (name, options) {
        if (["ksi", "kso", "gadc", "pwm"].includes(name)) { return options.fn(this); }
        return options.inverse(this);
    });

    /**
     *  returns true if any instance of given peripheral is active
     **/
    Handlebars.registerHelper('ifperi', function (peripherals, instance, options) {
        let  isPeri = false;
        peripherals.forEach((peri)=>{
            if ((peri.name.includes(instance)) && (peri.selected)) {
                isPeri=true;
            }
        } );
        if (isPeri){
            return options.fn(this)
        }
        return options.inverse(this);
    });

    /**
     * Prints passed in data, useful for debugging
     */
    Handlebars.registerHelper('print', function (data) {
        console.log(data);
    });

    /**
     * Returns the current year
     */
    Handlebars.registerHelper('curYear', function () {
        return new Date().getFullYear();
    });

    // Index is physical pin number, value is GPIO number
    const x2xxGPIOLut = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, undefined,
        undefined, undefined, undefined, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23,
         24, 25, 26, 27, 28, 29];

    /**
     * Returns name of pins being used in order to generate pin assignments
     */
    Handlebars.registerHelper('getPinNames', function (peri, selected_board, options) {
        let ret_val = "";
        if (peri.name !== "gpio") {
            let pinState = Array.from(peri.pinSelection);
            pinState.forEach((pin, index) => {
                let prefix = "PIN_" + peri.name.toUpperCase() + "_";
                let defaultPinName = peri.pinNames[index].replace(" ", "_");
                let secondName = "";
                let secondVal = "";
                if ((pin !== -1) && (pin !== null)) {
                    let pinName = "";
                    if (peri.name === "ksi") {
                        pinName = "PIN_ROW" + ((peri.rowCol[index] !== -1) ? peri.rowCol[index] : defaultPinName);
                        secondName = "ROW" + ((peri.rowCol[index] !== -1) ? peri.rowCol[index] : defaultPinName) + "_KSI";
                        secondVal = peri.pinNames[index];
                    } else if (peri.name === "kso") {
                        pinName = "PIN_COL" + ((peri.rowCol[index] !== -1) ? peri.rowCol[index] : defaultPinName);
                        secondName = "COL" + ((peri.rowCol[index] !== -1) ? peri.rowCol[index] : defaultPinName) + "_KSO";
                        secondVal = peri.pinNames[index];
                    } else if (peri.name === "pwm") {
                        pinName = prefix + defaultPinName;
                        secondName = "CH_PWM_INST" + peri.chanInst[index];
                        secondVal = peri.pinNames[index];
                    } else if (peri.name === "xpaon") {
                        if (defaultPinName === "tx") {
                            pinName = "PIN_XPAON";
                        } else if (defaultPinName === "rx") {
                            pinName = "PIN_XPARX";
                        }
                    } else if (peri.name === "qd") {
                        pinName = "PIN_" + defaultPinName.replace(/\[/g, '_').replace(/\]/g, '');
                    } else if (peri.name === "gadc") {
                        pinName = prefix + defaultPinName.replace("+", "P").replace("-", "M");
                        // Special Handeling for GADC Diff
                        if (peri.pinNames[index].includes("Diff")) {
                            let secondIndex = peri.pinLocation.findIndex(val =>
                                val.length === 1 && val[0] === pin[1]
                            );
                            secondName = "PIN_" + peri.pinNames[secondIndex]
                                .replace(" ", "_")
                                .replace("+", "P").replace("-", "M")
                                .replace("single", "diff")
                            secondVal = pin[1];
                            let pinIndex = peri.pinLocation.findIndex(val =>
                                val.length === 1 && val[0] === pin[0]
                            );
                            pinName = "PIN_" + peri.pinNames[pinIndex]
                                .replace(" ", "_")
                                .replace("+", "P").replace("-", "M")
                                .replace("single", "diff")
                            pin = pin[0];
                        }
                    } else if (peri.name === "qspi") {
                        // Remove QSPI Single Mode Hints and square brackets
                        pinName = prefix + defaultPinName.replace(/[^_]*_/g, '').replace(/[[\]]/g, '')
                    } else {
                        pinName = prefix + defaultPinName;
                    }

                    ret_val = ret_val + options.fn({
                        pinName: pinName.toUpperCase(),
                        pin: pin,
                        secondName: secondName,
                        secondVal: secondVal,
                    });
                }
            });
        } else {
            let pinState = Array.from(peri.pinIO);

            pinState.forEach((val, pin) => {
                if (val === 1 || val === 2) {
                    let pinName = peri.userPinNames[pin];
                    let gpioNum;

                    if (x2xxPlats.includes(get_version(selected_board))) {
                        gpioNum = x2xxGPIOLut[pin];
                    } else {
                        gpioNum = pin;
                    }

                    if (pinName === "") {
                        pinName = "GPIO_" + gpioNum;
                    }
                    ret_val = ret_val + options.fn({
                        pinName: pinName,
                        pin: gpioNum,
                    });
                }
            });
        }
        return ret_val;
    });

    /**
     * return atm_gpio function calls to inialize gpio as configured
     */
    Handlebars.registerHelper('genGPIOHelper', function (peri, selected_board, pullUps) {
        let ret_val = "";
        if (peri.name === "gpio") {
            let pinState = Array.from(peri.pinIO);
            pinState.forEach((val, pin) => {
                if (val === 1 || val === 2) {
                    let pinName = peri.userPinNames[pin];
                    if (pinName === "") {
                        let gpioNum;
                        if (x2xxPlats.includes(get_version(selected_board))) {
                            gpioNum = x2xxGPIOLut[pin];
                        } else {
                            gpioNum = pin;
                        }
                        pinName = "GPIO_" + gpioNum;
                    }
                    let func_params = "(" + pinName + ");\n";
                    ret_val += "    atm_gpio_setup" + func_params;
                    if (val === 1) {
                        ret_val += "    atm_gpio_set_input" + func_params;
                    } else if (val === 2) {
                        ret_val += "    atm_gpio_set_output" + func_params;
                    }
                    if (pullUps[pin] !== -1) {
                        ret_val += "    atm_gpio_set_pullup" + func_params;
                    }
                    ret_val += "\n";
                }
            });
        }
        return ret_val;
    });
}

    /**
     * generate the h files associated with the current pin configuration
     * @param config - object including all necessary info
     * @returns {string} - output h file.
     */
export function generate_h_file(config){
    return Handlebars.templates['board_h_template.hbs'](config);
}
